import { NotificationItemDTO, NotificationItemDTOCategory } from '@/api';
import { log } from '@/utils/functions/logger/logger';

/** The generated DTO type includes `null`; grouping always resolves to one of the known categories. */
type KnownCategory = Exclude<NotificationItemDTOCategory, null>;

const CATEGORY_ORDER: KnownCategory[] = [
  NotificationItemDTOCategory.GENERAL_INFORMATIONS,
  NotificationItemDTOCategory.OFFERS,
  NotificationItemDTOCategory.MY_OPERATIONS,
];

const FALLBACK_CATEGORY: KnownCategory = NotificationItemDTOCategory.GENERAL_INFORMATIONS;

interface NotificationGroup {
  category: KnownCategory;
  notifications: NotificationItemDTO[];
}

/** Groups notifications by category in the fixed display order, dropping empty sections. */
const groupNotificationsByCategory = (notifications: NotificationItemDTO[]): NotificationGroup[] => {
  const byCategory = new Map<KnownCategory, NotificationItemDTO[]>();

  notifications.forEach((notification) => {
    const rawCategory = notification.category;
    const isKnownCategory = !!rawCategory && CATEGORY_ORDER.includes(rawCategory);

    if (rawCategory && !isKnownCategory) {
      log.warn(`groupNotificationsByCategory: unknown category "${rawCategory}", falling back to ${FALLBACK_CATEGORY}`);
    }

    const category = isKnownCategory ? rawCategory : FALLBACK_CATEGORY;
    const group = byCategory.get(category) ?? [];
    group.push(notification);
    byCategory.set(category, group);
  });

  return CATEGORY_ORDER.map((category) => ({ category, notifications: byCategory.get(category) ?? [] })).filter(
    (group) => group.notifications.length > 0
  );
};

export { groupNotificationsByCategory };
export type { KnownCategory };
